export default __webpack_public_path__ + "static/media/avater3.b0f3d823.png";